export type HeaderMenuItem = {
  id: number;
  title: string;
  link: string | ((userId: string) => string);
  permissionKey?: string | string[];
  children?: HeaderMenuItem[];
};

const HEADER_MENU_ITEMS: HeaderMenuItem[] = [
  {
    id: 1,
    title: "List of Clients",
    link: (userId: string) => `/active-users/${userId}`,
    permissionKey: "user_list",
  },
  {
    id: 2,
    title: "Assign Agent",
    link: "/assign-agents",
    permissionKey: "agent_assign",
  },
  {
    id: 3,
    title: "Market Analysis",
    link: "/market-analysis",
    permissionKey: "market_analysis",
  },
  {
    id: 4,
    title: "Live Market",
    link: "#",
    permissionKey: "our_casino",
    children: [
      {
        id: 1,
        title: "Premium Casion",
        link: "/live-market/premium-casion",
      },
      {
        id: 2,
        title: "Tembo Casino",
        link: "/live-market/tembo-casino",
      },
      {
        id: 3,
        title: "VIP Casino",
        link: "/live-market/vip-casino",
      },
    ],
  },
  {
    id: 5,
    title: "Live Virtual Market",
    link: "#",
    permissionKey: "our_casino",
    children: [
      {
        id: 1,
        title: "20-20 DTL",
        link: "#",
      },
      {
        id: 2,
        title: "Amar Akbar Anthony",
        link: "#",
      },
    ],
  },
  {
    id: 4,
    title: "Reports",
    link: "#",
    children: [
      {
        id: 1,
        title: "Account Statement",
        link: "/account-statement",
        permissionKey: "account_statement",
      },
      {
        id: 2,
        title: "Current Bets",
        link: "/current-bets",
        permissionKey: "current_bets",
      },
      {
        id: 3,
        title: "General Report",
        link: "/general-report",
      },
      {
        id: 4,
        title: "Game Report",
        link: "/game-report",
      },
      {
        id: 5,
        title: "Casino Report",
        link: "/casino-report",
        permissionKey: "live_casino_result",
      },
      {
        id: 6,
        title: "Profit And Loss",
        link: "/profit-loss",
        permissionKey: "party_win_loss",
      },
      {
        id: 7,
        title: "Casino Result Report",
        link: "/casinoresult",
        permissionKey: "casino_result",
      },
      {
        id: 8,
        title: "General Lock",
        link: "/userlock",
        permissionKey: "general_lock",
      },
      {
        id: 9,
        title: "User Register Detail",
        link: "/userregisterdetail",
        permissionKey: "user_register_report",
      },
      {
        id: 10,
        title: "Total Profit Loss",
        link: "/totalprofitloss",
        permissionKey: "total_profitloss",
      },
      {
        id: 11,
        title: "User Win Loss",
        link: "/userwinloss",
        permissionKey: "user_winloss",
      },
    ],
  },
  {
    id: 7,
    title: "Multi Login",
    link: "/createaccount",
    permissionKey: "login_user_creation",
  },
];

export default HEADER_MENU_ITEMS;
